/* eslint-disable no-use-before-define */
import { getOrgDocuments } from 'api/documents.api';
import { getOrgFolders } from 'api/folders.api';
import { getOrgFinancialMetrics, createOrgFinancialMetrics } from 'api/metrics.api';
import { $form, $list, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import mergeDocumentsAndFolders from 'utils/mergeFilesAndFolders';

export const fetchAndSetFounderDocuments = async () => {
  $view.update({
    isLoading: true,
  });
  try {
    const [{ data: folders }, { data: documents }] = await Promise.all([
      getOrgFolders(),
      getOrgDocuments(),
    ]);

    const data = mergeDocumentsAndFolders(documents, folders);

    $list.update({
      data,
    });
    $view.update({
      folderOptions: folders.map(folder => ({
        label: folder.name,
        value: folder.id,
      })),
    });
  } catch (error) {
    displayError({
      message: 'Failed to load documents. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isLoading: false,
    });
  }
};

export const fetchAndSetFinancialData = async () => {
  let data = null;
  try {
    $view.update({
      isFormLoading: true,
    });
    data = await getOrgFinancialMetrics();

    $form.update({
      postMoneyValuation: data.postMoneyValuation || 0,
      amountPreviouslyRaised: data.amountPreviouslyRaised || 0,
      arr: data.arr || 0,
      mrr: data.mrr || 0,
      otherRevenue: 0,
      cashOnHand: data.cashOnHand,
      currentLiabilities: data.liabilities || 0,
      investments: data.investments || 0,
      other: data.other || 0,
      otherAssets: data.otherAssets || 0,
      liabilities: data.liabilities || 0,
    });
  } catch (error) {
    if (data === null) {
      await createOrgFinancialMetrics({
        postMoneyValuation: 0,
        amountPreviouslyRaised: 0,
        arr: 0,
        mrr: 0,
        cashOnHand: 0,
        liabilities: 0,
        investments: 0,
        otherAssets: 0,
      });
    } else {
      displayError({
        message: 'Failed to load financial data. Please refresh the page.',
        title: 'Loading Error',
      });
    }
  } finally {
    $view.update({
      isFormLoading: false,
    });
  }
};
